export const CHARTS_NUMBER_OF_PERIODS = 2;
